export class Login {
  constructor() {
    this.username, this.password;
  }
}
